type FieldKey =
	| 'fullName'
	| 'nickname'
	| 'timezone'
	| 'locale'
	| 'title'
	| 'phoneNumber'
	| 'companyName'
	| 'department'
	| 'location'
	| 'email';

interface SimpleConstraint {
	allowed: boolean;
	reason?: { key: string };
}

type MutabilityContraints = {
	[key: string]: SimpleConstraint | MutabilityContraints;
};

const MUTABILITY_DETAILS_MAP: Record<FieldKey, string> = {
	fullName: 'name',
	nickname: 'nickname',
	timezone: 'zoneinfo',
	locale: 'locale',
	email: 'email',
	// extended profile
	title: 'extended_profile.job_title',
	phoneNumber: 'extended_profile.phone_number',
	companyName: 'extended_profile.organization',
	department: 'extended_profile.department',
	location: 'extended_profile.location',
};

const CUSTOM_FIELD_PLACE = {
	email: 'email.initiateChange',
	picture: 'avatar',
} as const;

type CustomFieldKey = keyof typeof CUSTOM_FIELD_PLACE;
type AllFieldKeys = FieldKey & CustomFieldKey;

const getFieldConfig = (
	data: MutabilityContraints,
	field: AllFieldKeys,
): SimpleConstraint | undefined => {
	if ((field === 'email' || field === 'picture') && CUSTOM_FIELD_PLACE[field]) {
		return data[CUSTOM_FIELD_PLACE[field]] as SimpleConstraint | undefined;
	}
	const mappedFieldKey = MUTABILITY_DETAILS_MAP[field];

	// @ts-ignore
	return data['profile.write'][mappedFieldKey] as SimpleConstraint | undefined;
};

const getMutabilityConstraintFor = (
	data: MutabilityContraints,
	field: AllFieldKeys,
): { field: AllFieldKeys; reason: string | null } | null => {
	const fieldConfig = getFieldConfig(data, field);
	if (!fieldConfig || fieldConfig.allowed) {
		return null;
	}

	const reason = fieldConfig.reason;
	return {
		field,
		reason: (reason && reason.key) || null,
	};
};

export const transformUserManageConfig = (data: MutabilityContraints) => ({
	mutabilityConstraints: Object.keys(MUTABILITY_DETAILS_MAP)
		// @ts-ignore
		.map((field: AllFieldKeys) => getMutabilityConstraintFor(data, field))
		.filter((truthy) => truthy),
});
